// housewarming — Yangi uy open-house card (u01).
//
// Hand-warmed paper invitation. Outer terracotta tile ring frames a
// cream inner page with a round medallion holding a small brick-house
// silhouette (or a photo). "OCHILISH" eyebrow in roman small-caps,
// Lora names, small-caps date + venue caption.
import { Photo, type LayoutCtx } from "./_shared";

export function HousewarmingLayout({
  names,
  date,
  venue,
  accent,
  ink,
  bg,
  font,
  photo,
}: LayoutCtx) {
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: `linear-gradient(150deg, ${accent}44 0%, ${accent}11 50%, ${accent}44 100%)`,
        padding: "5%",
        display: "flex",
      }}
    >
      <div
        style={{
          flex: 1,
          background: bg,
          color: ink,
          position: "relative",
          padding: "8%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          boxShadow: `inset 0 0 0 1px ${accent}55, inset 0 0 0 5px ${bg}, inset 0 0 0 6px ${accent}55`,
        }}
      >
        {/* Tiny keyhole ribbon under the eyebrow */}
        <div
          aria-hidden
          style={{
            position: "absolute",
            top: "6%",
            left: "20%",
            right: "20%",
            height: 2,
            background: `linear-gradient(90deg, transparent, ${accent}, transparent)`,
            opacity: 0.55,
          }}
        />

        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 7,
            fontWeight: 700,
            letterSpacing: "0.4em",
            color: accent,
            marginBottom: "5%",
          }}
        >
          OCHILISH
        </div>

        {/* Round medallion */}
        <div
          style={{
            width: "60%",
            aspectRatio: "1 / 1",
            position: "relative",
            marginBottom: "5%",
            borderRadius: "50%",
            overflow: "hidden",
            boxShadow: `0 0 0 4px ${bg}, 0 0 0 5px ${accent}66`,
          }}
        >
          <Photo
            src={photo}
            style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }}
            fallback={
              <>
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    background: `radial-gradient(circle at 50% 55%, ${accent}33, ${bg})`,
                  }}
                />
                {/* Brick-house silhouette */}
                <svg viewBox="0 0 80 80" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }} aria-hidden>
                  <path d="M16 38 L40 22 L64 38 L64 60 L16 60 Z" fill={accent} opacity="0.7" />
                  <path d="M16 38 L40 22 L64 38" fill="none" stroke={ink} strokeWidth="0.6" opacity="0.5" />
                  <rect x="34" y="46" width="12" height="14" fill={bg} opacity="0.85" />
                  <rect x="34" y="46" width="12" height="14" fill="none" stroke={ink} strokeWidth="0.5" opacity="0.5" />
                  {/* Smoke wisps */}
                  <path d="M52 24 Q 54 20 52 16 Q 50 12 52 8" fill="none" stroke={accent} strokeWidth="0.8" opacity="0.55" />
                </svg>
              </>
            }
          />
        </div>

        <div style={{ fontFamily: font, fontSize: 28, lineHeight: 1.1, fontWeight: 500, color: ink }}>
          {names}
        </div>

        <div style={{ flex: 1 }} />

        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6.5,
            fontWeight: 700,
            letterSpacing: "0.32em",
            color: accent,
            marginTop: "4%",
          }}
        >
          OCHILISH · {date.toUpperCase()}
        </div>
        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6,
            fontWeight: 600,
            letterSpacing: "0.28em",
            color: `${ink}99`,
            marginTop: 6,
          }}
        >
          {venue.toUpperCase()}
        </div>
      </div>
    </div>
  );
}
